import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBestPrice = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "bestPrice",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13129",
			fill: "none",
			d: "M0,0h30v30H0V0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13130",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M10.1,9.3c0.2,0.2,0.2,0.5,0,0.7c-0.2,0.2-0.5,0.2-0.7,0c-0.2-0.2-0.2-0.5,0-0.7c0,0,0,0,0,0C9.6,9.1,9.9,9.1,10.1,9.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13131",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M8.7,3l3.8,0c0.7,0,1.4,0.3,1.9,0.8l11.9,11.9c1,1,1,2.7,0,3.8c0,0,0,0,0,0l-6.8,6.8c-1,1-2.7,1-3.8,0c0,0,0,0,0,0L3.8,14.3C3.3,13.8,3,13.2,3,12.5V8.7C3,8,3.3,7.3,3.8,6.8l3-3C7.3,3.3,8,3,8.7,3L8.7,3z"
		})
	]
});
export default SvgBestPrice;
